<template>
  <ul class="nav nav-mobile-menu">

  </ul>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  computed: {
    getLocation() {
      return this.$store.getters.getLocation;
    }
  },
  methods: {
    changeLocation(location){
      this.$lang.setLang(location);
      this.$store.commit("setLocation", location);
    }
  }
};
</script>

<style lang="scss" scoped>

.location-flag {
  padding-right:10px;
}
</style>